import React, { useCallback, useState } from "react"
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Drawer, List, ListItem, ListItemButton, ListItemText } from "@mui/material"
import PropTypes from "prop-types"
import { getAuth } from "firebase/auth"
import { makeStyles } from "@mui/styles"

const styles = {
    root: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    logout: {
        box: {
            height: '48px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#eee',
        },
        button: {
            color: '#f99',
            fontWeight: 'bold'
        },
    },
}

const useStyles = makeStyles(styles)

const LeftDrawerView = ({ open, onClose, onUserAdmin, onImageUpload }) => {

    const [openConfirmLogout, setOpenConfirmLogout] = useState(false)
    const onLogout = useCallback(() => {
        const auth = getAuth()
        auth.signOut()
    }, [])

    return (
        <Drawer
            open={open}
            onClose={onClose}
        >
            <Box style={styles.root}>
                <List>
                    <ListItem>
                        <ListItemButton onClick={onUserAdmin}>
                            <ListItemText>ユーザ管理</ListItemText>
                        </ListItemButton>
                    </ListItem>
                    <ListItem>
                        <ListItemButton onClick={onImageUpload}>
                            <ListItemText>樹木画像アップロード</ListItemText>
                        </ListItemButton>
                    </ListItem>
                </List>
                <Box style={styles.logout.box}>
                    <Button style={styles.logout.button} onClick={() => setOpenConfirmLogout(true)}>ログアウト</Button>
                </Box>
            </Box>
            <Dialog
                open={openConfirmLogout}
            >
                <DialogTitle>ログアウト</DialogTitle>
                <DialogContent>
                    <DialogContentText>本当にログアウトしますか</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button>キャンセル</Button>
                    <Button color="secondary" onClick={onLogout}>ログアウト</Button>
                </DialogActions>
            </Dialog>
        </Drawer>
    )
}
LeftDrawerView.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onUserAdmin: PropTypes.func,
    onImageUpload: PropTypes.func,
}

export default LeftDrawerView